import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Route
} from "@angular/router";
import { AuthService } from "./auth.service.service";

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    console.log('next',next)
    console.log('state',state)
    if (!this.auth.isAuthenticated()) {
      this.router.navigate([""]);
      return false;
    }

    if (state.url === "/") {

      this.router.navigate(["admin"]);
    }
    return true;
  }
}
